const { default: Swiper } = require("swiper");
const { Navigation, Thumbs } = require("swiper/modules");
const {
  default: ProductConfigure,
} = require("../../src/js/components/product-configure");
const { default: Comments } = require("../../src/js/components/comments");

class SingleProduct {
  constructor() {
    this.sliderInit();
    this.tabsInit();
    new ProductConfigure();
    new Comments();
  }

  sliderInit = () => {
    const slider = new Swiper(".js-list-slider", {
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 20,
    });
    const sliderThumb = new Swiper(".js-thumb-slider", {
      modules: [Navigation, Thumbs],
      slidesPerView: 1,
      navigation: {
        nextEl: ".thumb-button-next",
        prevEl: ".thumb-button-prev",
      },
      thumbs: {
        swiper: slider,
        autoScrollOffset: 1,
      },
    });
    const reviewsSlider = new Swiper(".js-comment-slider", {
      slidesPerView: "auto",
      spaceBetween: 20,
      modules: [Navigation],
      navigation: {
        nextEl: ".comment-button-next",
        prevEl: ".comment-button-prev",
      },
    });
    const tabsSlider = new Swiper(".js-tabs-slider", {
      slidesPerView: "auto",
    });
  };
  tabsInit = () => {
    const tabsNav = document.querySelectorAll(".js-tab-item");
    const tabsItems = document.querySelectorAll(".js-info-tab");
    if (tabsNav.length == 0 || tabsItems.length == 0) {
      return;
    }
    tabsNav.forEach((item, index) => {
      item.addEventListener("click", () => {
        tabsNav.forEach((tab) => {
          if (tab != item) {
            tab.classList.remove("active");
          }
        });
        tabsItems.forEach((tab) => {
          if (tab != tabsItems[index]) {
            tab.classList.remove("active");
          }
        });
        item.classList.add("active");
        tabsItems[index].classList.add("active");
      });
    });
  };
}

new SingleProduct();
